const defaultData = [
  { name: '1四川服途物流有限公司', price: 21254.25 },
  { name: '遂宁市安正物流有限公司', price: 21254.25 },
  { name: '四川瑞科达物流信息咨询服务有限公司', price: 3556.25 },
  { name: '遂宁市洪顺物流有限公司', price: 19885.2 },
  { name: '四川意远物流有限公司', price: 23552.2 },
  { name: '四川绿然源物流有限公司', price: 2698.25 },
  { name: '遂宁中海鹤汇农特产品冷链物流有限公司', price: 5984.29 },
  { name: '遂宁市慧鑫物资有限公司', price: 12465.88 },
  { name: '遂宁远望物流有限公司', price: 5146.87 },
  { name: '遂宁市安正物流有限公司', price: 26542.36 },
  { name: '遂宁市揽月物流有限公司', price: 21562.63 },
  { name: '遂宁市勤道物流有限公司', price: 5165.89 },
  { name: '遂宁市众享冷链物流配送有限公司', price: 1651.35 },
  { name: '遂宁市坦途物流有限公司', price: 38423.77 },
  { name: '遂宁胜意物流有限公司', price: 12564.84 },
  { name: '遂宁市伴友冷链物流有限公司', price: 16541.57 },
  { name: '遂宁市平林物流有限公司', price: 12654.96 },
  { name: '遂宁市宏通物流有限公司', price: 17887.87 },
  { name: '遂宁市成航冷链物流有限公司', price: 1658.45 },
  { name: '遂宁市众旺运输服务有限公司', price: 16865.32 },
  { name: '遂宁鼎泰汇物流有限公司', price: 16865.32 },
  { name: '遂宁川达物流有限公司', price: 15855.85 },
  { name: '遂宁市丰生物流有限公司', price: 26552.78 },
  { name: '遂宁全物成瑞物流有限公司', price: 1562.52 },
  { name: '遂宁市昊运物流有限公司', price: 1564.98 },
  { name: '四川汇加物流有限公司', price: 16582.685 },
  { name: '遂宁市洪顺物流有限公司', price: 16845.52 }
]

export default defaultData
